<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import UITabsSelect from '@/components/ui/TabsNav/UITabsSelect.vue';

export type SettingsRailItem = {
  name: string;
  route: string;
  /** Detail routes that keep their list's rail entry highlighted. */
  relatedRoutes?: string[];
};
export type SettingsRailGroup = { heading: string; items: SettingsRailItem[] };

const props = defineProps<{ groups: SettingsRailGroup[] }>();

const route = useRoute();

const items = computed(() => props.groups.flatMap((group) => group.items));
const activeItem = computed(
  () =>
    items.value.find(
      (item) =>
        item.route === route.name ||
        item.relatedRoutes?.includes(route.name as string),
    ) ?? items.value[0],
);
</script>

<template>
  <nav class="md:border-r md:border-r-gpx_gray-800 md:pr-[18px]">
    <div class="hidden md:block">
      <div v-for="group in groups" :key="group.heading" class="mb-[22px]">
        <p
          class="mb-[8px] pl-[11px] text-xs font-semibold uppercase tracking-wider text-gpx_gray-200"
        >
          {{ group.heading }}
        </p>
        <router-link
          v-for="item in group.items"
          :key="item.route"
          :to="{ name: item.route }"
          :aria-current="item.route === activeItem?.route ? 'page' : undefined"
          class="block rounded-r-[5px] border-l-2 py-[6px] pl-[9px] pr-[8px] text-sm"
          :class="
            item.route === activeItem?.route
              ? 'border-l-gpx_terracotta-200 bg-gpx_terracotta-900 font-semibold text-gpx_terracotta-100'
              : 'border-l-transparent text-gpx_black-400 hover:bg-gpx_gray-900'
          "
        >
          {{ item.name }}
        </router-link>
      </div>
    </div>
    <UITabsSelect
      v-if="activeItem"
      class="w-full md:hidden"
      :tabs="items"
      :current="activeItem"
    />
  </nav>
</template>
